export const APP_NAME = 'Piccard'

/**
 * Media length cap (minutes) for the synchronous transcribe flow — DERIVED, not
 * arbitrary. It is the min of the two real ceilings: (a) the 100MB Worker body
 * limit ≈ ~100 min of mp3-128k, and (b) the 4-min poll timeout staying safe if
 * AssemblyAI degrades from its measured ~140x real-time down to ~30x on long
 * files (≈ 90 min → 180 s < 240 s poll). 90 covers ~99% of podcasts/lectures.
 * The CF platform is NOT the limit (HTTP wall is unlimited while the client is
 * connected; AAI polling is pure I/O, excluded from Worker CPU time). Defer only
 * the async DO pipeline (M2) if we ever need >90 min — it's a UX/predictability
 * gate, not a platform ceiling. See .claude/plans + memory video-learning-feature.
 */
export const MEDIA_MAX_DURATION_MIN = 90
